<template>
  <div class="ll-change-content">
    <div class="ll-change-content_title">
      {{ title }}
    </div>
    <div class="ll-change-content_subtitle">
      <div class="ll-change-content_subtitle-text">
        {{ subtitle }}
        <WsTextChip001
          gray
          thin
          icon-xl
          leading-icon="icon-time"
          :text-label="_date"
        />
      </div>
      <div class="ll-change-content_subtitle-btn">
        <WsButton001
          flat-button
          out-line
          width-stretch
          leading-icon="icon-edit"
          @click="$_onClick()"
        >
          {{ btnText }}
        </WsButton001>
      </div>
    </div>
    <div class="ll-change-content_description">
      {{ description }}
    </div>
    <div class="ll-change-content_list">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlChangeContent",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default() {
        return this.$t("敘述（變動因素描述）");
      },
    },
    btnText: {
      type: String,
      default() {
        return this.$t("編輯敘述");
      },
    },
    dateTitle: {
      type: String,
      default() {
        return this.$t("編輯日期");
      },
    },
    date: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  computed: {
    _date() {
      return `${this.dateTitle}${this.date}`;
    },
  },
  methods: {
    $_onClick() {
      this.$emit("edit-click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-change-content";
</style>